<div class="page-header">
  <div>
    <h1>{{ t('EditUsersTitle') }}</h1>
    <p>{{ t('AdminDescription') }}</p>
  </div>
  <button class="primary-button" type="button" (click)="createModalOpen = true">{{ t('AddUserButton') }}</button>
</div>

@if (error) {
  <p class="message error">{{ error }}</p>
}
@if (success) {
  <p class="message success">{{ success }}</p>
}
@if (loading) {
  <p>{{ t('HubUsersLoading') }}</p>
}

@if (!loading) {
  <div class="card">
    <table class="table">
      <thead>
        <tr><th>{{ t('UserEmailLabel') }}</th><th>{{ t('HubRoles') }}</th><th>{{ t('ChangePassword') }}</th><th></th></tr>
      </thead>
      <tbody>
        @for (user of users; track user) {
          <tr>
            <td [attr.data-label]="t('UserEmailLabel')">{{ user.email }}</td>
            <td class="roles" [attr.data-label]="t('HubRoles')">
              <label class="checkbox-label"><input type="checkbox" [ngModel]="user.admin" (ngModelChange)="setRole(user, 'admin', $event)"> {{ t('AdminLabel') }}</label>
              <label class="checkbox-label"><input type="checkbox" [ngModel]="user.processAdmin" (ngModelChange)="setRole(user, 'processAdmin', $event)"> {{ t('HubProcessAdminRole') }}</label>
              <label class="checkbox-label"><input type="checkbox" [ngModel]="user.translator" (ngModelChange)="setRole(user, 'translator', $event)"> {{ t('HubTranslatorRole') }}</label>
            </td>
            <td [attr.data-label]="t('ChangePassword')">
              <form class="inline-form" (ngSubmit)="setPassword(user)">
                <input [name]="'password-' + user.id" [(ngModel)]="passwords[user.id]" [placeholder]="t('UserPasswordLabel')">
                <button class="secondary-button" type="submit">{{ t('ChangePassword') }}</button>
              </form>
            </td>
            <td data-label=""><button class="danger-button" type="button" (click)="deleteUser(user)">{{ t('DeleteUserButton') }}</button></td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}

@if (createModalOpen) {
  <div class="modal-backdrop" (click)="createModalOpen = false">
    <form class="modal-card" (click)="$event.stopPropagation()" (ngSubmit)="createUser()">
      <h2>{{ t('AddUserButton') }}</h2>
      <label>{{ t('UserEmailLabel') }}<input name="email" type="email" [(ngModel)]="newEmail" required></label>
      <label>{{ t('UserPasswordLabel') }}<input name="password" [(ngModel)]="newPassword" required></label>
      <label class="checkbox-label"><input name="admin" type="checkbox" [(ngModel)]="newAdmin"> {{ t('UserIsAdminLabel') }}</label>
      <div class="button-row">
        <button class="secondary-button" type="button" (click)="createModalOpen = false">{{ t('DeleteUserCancelButtonLabel') }}</button>
        <button class="primary-button" type="submit">{{ t('HubCreate') }}</button>
      </div>
    </form>
  </div>
}
